export default __webpack_public_path__ + "static/media/fortuneLadyCoin.d27d6058.png";